import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/Bits";

const Box = ({ title, to, children, testId }) => (
  <div className="rounded-2xl border border-border bg-card p-5" data-testid={testId}>
    <div className="flex items-center justify-between mb-3"><h3 className="font-serif uppercase text-navy">{title}</h3>{to && <Link to={to} className="text-xs text-pinkb">Open</Link>}</div>
    {children}
  </div>
);
const Empty = ({ t }) => <p className="text-sm text-muted-foreground">{t}</p>;

export const AttentionPanel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/attention").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="mb-8" data-testid="admin-attention">
      <div className="eyebrow mb-3">Needs your attention</div>
      <div className="grid gap-4 lg:grid-cols-2">
        <Box title="Questions not in the knowledge bank" to="/admin/queue" testId="attention-flagged">
          {d.flagged.length === 0 ? <Empty t="Nothing flagged." /> : <ul className="space-y-2 text-sm">{d.flagged.map((q) => <li key={q.id}>{q.question}<div className="text-xs text-muted-foreground">{q.user_name} · {q.status} · {fmtDate(q.created_at)}</div></li>)}</ul>}
        </Box>
        <Box title="Latest beta feedback" to="/admin/surveys" testId="attention-feedback">
          {d.surveys.length === 0 ? <Empty t="No feedback yet." /> : <ul className="space-y-2 text-sm">{d.surveys.map((x) => <li key={x.id}>{x.most_valuable || "—"}<div className="text-xs text-muted-foreground">{x.user_name} · NPS {x.nps} · {fmtDate(x.created_at)}</div></li>)}</ul>}
        </Box>
        <Box title="Members by Roots Phase" to="/admin/members" testId="attention-phases">
          <div className="flex gap-3">{Object.entries(d.phases).map(([k, v]) => <div key={k} className="flex-1 rounded-xl bg-secondary p-3 text-center"><div className="font-serif text-2xl text-navy">{v}</div><div className="text-[10px] uppercase text-muted-foreground">Phase {k}</div></div>)}</div>
        </Box>
        <Box title="Open to partnerships" to="/admin/members" testId="attention-partners">
          {d.partners.length === 0 ? <Empty t="No members have ticked this yet." /> : <ul className="space-y-1 text-sm">{d.partners.map((m) => <li key={m.id}>{m.name} · {m.business_name} <span className="text-xs text-muted-foreground">({m.audience || "—"}{m.growth_phase ? `, Phase ${m.growth_phase}` : ""}) · {m.email}</span></li>)}</ul>}
        </Box>
        <Box title="Weekly on-track email" testId="attention-weekly">
          <p className="text-sm">This week: <b data-testid="weekly-sent">{d.weekly.sent_this_week}</b> sent · <b data-testid="weekly-pending">{d.weekly.pending_this_week}</b> pending</p>
          <p className="text-xs text-muted-foreground mt-1">{d.weekly.last_run ? `Last run ${fmtDate(d.weekly.last_run.at)} (${d.weekly.last_run.sent} sent)` : "Sends every Monday at 8am."}</p>
        </Box>
      </div>
    </div>
  );
};
